exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon_staff{width:18px !important;height:18px !important}.btn_action_account{border:none !important;background-color:transparent !important}.btn_action_account:hover{background-color:transparent !important}\n", ""]);

// exports
